var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1876 32.1505C30.1876 27.9935 24.7957 24.6236 18.1446 24.6236C11.4934 24.6236 6.10156 27.9935 6.10156 32.1505M18.1446 20.1075C13.9876 20.1075 10.6177 16.7376 10.6177 12.5806C10.6177 8.42361 13.9876 5.05371 18.1446 5.05371C22.3016 5.05371 25.6715 8.42361 25.6715 12.5806C25.6715 16.7376 22.3016 20.1075 18.1446 20.1075Z",
    stroke: "white",
    strokeWidth: 1.72043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWPeople);
export default __webpack_public_path__ + "static/media/WPeople.4267bc4ea7e7eb433c21780075e9cf3b.svg";
export { ForwardRef as ReactComponent };